module.exports = __webpack_public_path__ + "static/media/S (177).f9dda75d.jpg";